module.exports = __webpack_public_path__ + "/images/ico-max-share.08aa2cc.svg";